import { getFileNameFromContentDisposition } from './commonHelpers';
import { saveAs } from 'file-saver';
import Vue from 'vue';
import { notificationsRenderer } from '@/helpers/renderHelpers';

export default async (url, payload = null, method = 'get') => {
  try {
    let response;
    const responseType = 'blob';
    if (method === 'get') {
      const params = payload;
      response = await Vue.http.get(url, {params, responseType})
    } else if (method === 'post') {
      response = await Vue.http.post(url, payload, {responseType})
    }
    const disposition = response.headers.get('content-disposition'),
      fileName = getFileNameFromContentDisposition(disposition, 'report');
    saveAs(response.body, fileName);
  } catch (e) {
    console.log(e)
    notificationsRenderer(e.data, 'error');
  }
}



// WEBPACK FOOTER //
// ./src/helpers/export-excel-helper.js